<template>
  <div>
    <van-popup
      v-model="isWeChat"
      position="right"
      :style="{ height: '100%', width: '100%', background: '#f5f5f5' }"
    >
      <van-nav-bar :style="{ 'background-color': '#f9f9f9' }">
        <van-icon size="20" slot="left" @click="close" name="arrow-left" color="#333" />
        <div slot="title">绑定/解绑微信</div>
      </van-nav-bar>
      <div v-if="!isBinding" class="we-chat">
        <p>
          请在5分钟内用微信扫描下方的二维码，关注公众号，进行微信与系统账号的绑定，必须用自己账号登陆系统扫描的二维码，切勿扫其他人的二维码。
        </p>
        <div v-if="isWechatImg">
          <img :src="wechatCodeUrl" alt style="width: 100%" />
        </div>
        <div class="save_btn">截图保存图片</div>
      </div>
      <div v-else class="we-chat">
        <p>您已经成功绑定微信</p>
        <div class="unbind_btn" @click="unbind">解绑微信</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "centerpwd",
  props: {
    isWeChat: Boolean
  },
  data() {
    return {
      isBinding: false,
      isWechatImg: false,
      wechatCodeUrl: {},
      parentInfo: {}
    };
  },
  watch: {
    isWeChat: {
      handler(newVal) {
        if (newVal) {
          this.getWeChat();
        }
      },
      deep: true
    }
  },
  created() {
    this.parentInfo = this.$store.state.parentInfo.userInfo;
    if (this.isWeChat) this.scanLogin();
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("listenToWeChat", false);
    },
    //登陆用户是否绑定微信
    async scanLogin() {
      this.xy.loading();
      let res = await this.xyapi.get(
        `${this.xyMApi}/api/Users/BindWeChatByUser`,
        null
      );
      if (res.success) {
        if (res.data) {
          this.isBinding = true;
          this.xy.unloading();
        } else {
          this.getWeChat();
          this.isBinding = false;
        }
      }
    },
    async getWeChat() {
      let res = await this.xyapi.post(`${this.xyMApi}/xy/comm/ScanFollow`, null);
      if (res.success) {
        if (res.data.qrCodeUrl) {
          //显示微信图片
          this.isWechatImg = true;
          this.wechatCodeUrl = res.data.qrCodeUrl;
          this.scanLogin();
        }
      } else {
        this.isWechatImg = false;
      }
      this.xy.unloading();
    },
    async unbind() {
      this.xy.loading();
      let res = await this.xyapi.post(
        `${this.xyMApi}/api/Users/RemoveWeChatOpenID?userId=${this.parentInfo.UserID}`,
        null
      );
      if (res.success) {
        this.$emit("listenToWeChat", false);
        this.isBinding = false;
        this.xy.msgSuc("解绑成功");
      }
    }
  }
};
</script>
<style lang="less" scoped>
.we-chat {
  width: 85%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  border-radius: 42px;
  padding: 50px;
  position: absolute;
  bottom: 150px;
  top: 150px;
  left: 0;
  right: 0;
  p {
    font-size: 28px;
    color: rgba(51, 51, 51, 1);
  }
  .save_btn,
  .unbind_btn {
    margin-top: 40px;
    text-align: center;
  }
  .unbind_btn {
    font-size: 30px;
    color: #4196ff;
  }
}
</style>
